import { Modal, ModalProps } from "@mantine/core"
import { useBreakpoints } from "../../utils/use-breakpoints"
import { SuspenseWithErrorBoundary } from "../suspense"

export interface DefaultModalProps extends ModalProps {}

export function DefaultModal({ children, ...props }: DefaultModalProps) {
  const { xs } = useBreakpoints()
  return (
    <Modal centered fullScreen={xs} {...props}>
      <SuspenseWithErrorBoundary>{children}</SuspenseWithErrorBoundary>
    </Modal>
  )
}
